<!-- Screenname:Store Sub Tab
Developer Name:Tharuni.
Created date on:1/02/2023
Last Working date on:
Comments and Suggestions:
TS File:StoreService -->
<template>
  <div>
    <b-form ref="formRef" @submit.prevent="IsSubmitSub">
      <b-row>
        <b-col lg="3" md="4" sm="8" cols="12">
          <div class="field">
            <TextField v-model="dataModelSub.Code" class="DS-Id" type="text" placeholder="" disabled name="Code"
              :label="$t('5000.storeid')" id="Code" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <TextField v-model="dataModelSub.Name" class="DS-Id" type="text" placeholder="" name="Store Name"
              :label="$t('5000.storename')" :rules="{ required: true }" id="Store Name" :required-icon="true"
              case="Capital" :autofocus="true" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptionsSub.branchId" :disabled="editDisabled"
              :items="selectOptionsSub.branchOptions" :label="$t('5000.StoreBranch')" :rules="{ required: true }"
              :required-icon="true" id="Store Branch" name="Store Branch" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptionsSub.MappingbranchId" :disabled="editDisabled"
              :items="selectOptionsSub.MappingbranchOptions" :label="$t('5000.MappingBranch')"
              :rules="{ required: true }" :required-icon="true" id="Branch mapping" name="Branch mapping"
              @update:modelValue="LoadMainDeptStore" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <CustomDropDown v-model="managedOptionsSub.managedValue" :items="managedOptionsSub.options"
              @update:modelValue="managedAtOnchangeSub" id="managed" name="Managed At" :disabled="editDisabled"
              :label="$t('5000.inventorymanagedat')" :rules="{ required: true }" :required-icon="true" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12" v-if="managedOptionsSub.managedValue == '2'">
          <div class="field">
            <Branch v-model="selectOptionsSub.branchValue" @update:modelValue="handleUpdateValueSub"
              :disabled="editDisabled" name="Branch" id="Branch" />
          </div>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">

            <CustomTextarea name="BillingAddress" :label="$t('5000.billingaddress')" :rules="{ required: false }"
              id="BillingAddress" v-model="dataModelSub.BillingAddress" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">

            <CustomTextarea name="ShippingAddress" :label="$t('5000.shippingaddress')" :rules="{ required: false }"
              id="ShippingAddress" v-model="dataModelSub.Address" />
          </div>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-if="loading" v-model="selectOptionsSub.mainStoreValue"
              :items="selectOptionsSub.mainStoreOptions" name="Main Store" :label="$t('5000.chooseMainStore')"
              :rules="{ required: true }" :required-icon="true" id="Main Store" />
          </div>
        </b-col>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-if="loading" v-model="selectOptionsSub.deptStoreValue"
              :items="selectOptionsSub.deptStoreOptions" name="Department Store" :label="$t('5000.chooseDeptStore')"
              :rules="{ required: false }" id="Department Store" />
          </div>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col lg="6" md="6" sm="8" cols="8">
          <div class="field">
            <label path="Branch">{{ $t("5000.transactionallowed") }}</label>

            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsSub.isTransaction" inputId="ingredient1" name="Yes" value="true" />
                <label for="ingredient1" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsSub.isTransaction" inputId="ingredient2" name="No" value="false" />
                <label for="ingredient2" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col>
      </b-row> -->

      <b-row>
        <b-row class="pe-0">
          <b-col lg="12" md="12" sm="12" cols="12" class="pe-0">
            <div class="field">
              <Description v-model="dataModelSub.Remarks" v-if="loading" ref="childref" name="Description"
                :label="$t('5000.description')" :rules="{ required: false }" id="Description" />
            </div>
          </b-col>
        </b-row>
      </b-row>
      <b-row>
        <b-col>
          <Footer @cancel="IsClear()" :cancelhide="false" :label="label" :loading="Saveloader" />
        </b-col>
      </b-row>
    </b-form>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";

import Description from "../../../../../../../components/FormComponents/TextArea.vue";
import Cancel from "../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../../components/GeneralButtons/SaveButton.vue";

import Branch from "../../../../../../../components/FormComponents/BranchDropdown.vue";
import commonservice from "../../../../../Service/StoreService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import CustomDropDown from "../../../../../../../components/FormComponents/Dropdown.vue";
import MultiSelectDropDown from "../../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import common from "../../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomTextarea from "../../../../../../../components/FormComponents/TextArea.vue";
import LoginService from "../../../../../../../Services/LoginService";

export default defineComponent({
  components: {
    Description,
    Cancel,
    Save,
    Branch,
    CustomDropDown,
    MultiSelectDropDown,
    TextField,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    CustomTextarea,
  },
  props: {
    SubStoreRights: {
      type: Object,
      default: {},
    },
  },
  setup(props) {
    debugger;
    /*Declaration Starts*/
    let loading = ref(false);
    let Saveloader = ref(false);
    const routes = useRouter();
    const router = useRoute();
    console.log(router.query);
    const storeId = router.query.storeId;
    const storeType = router.query.storeType;
    const childref = ref();
    const { t } = useI18n();

    const label = ref(t("btn.save"));

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    let session: any = localStorage.getItem("UsersData");
    let EntityData: any = localStorage.getItem("EntityData");
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    session = JSON.parse(session);
    EntityData = JSON.parse(EntityData);

    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let EntityId = Number(EntityData.EntityId);
    let AddressVar = String(session.AddressVar);

    const dataModelSub = ref({
      Code: "",
      Name: "",
      BranchId: BranchId,
      IsBranchId: 0,
      Remarks: "",
      Managedby: 0,
      StoreTypeID: 2,
      CreatedBy: 0,
      ModifiedBy: 0,
      HospitalId: HospitalId,
      CreatedAt: "",
      ModifiedAt: "",
      TransactionBilling: false,
      Id: 0,
      ManagedBy: 0,
      EntityId: 0,
      EntityOperationId: 0,
      Address: "",
      BillingAddress: "",
    });
    const copydataModelSub = JSON.parse(JSON.stringify(dataModelSub.value));
    let mainStoreOptionsCopy = [];
    let deptStoreOptionsCopy = [];
    const managedOptionsSub = ref({
      options: [
        { name: "Hospital", value: 1 },
        { name: "Branch", value: 2 },
      ],
      managedValue: ref(),
    });
    const selectOptionsSub: any = ref({
      branchValue: ref(),
      isTransaction: "",
      mainStoreOptions: [],
      mainStoreValue: ref(),
      deptStoreOptions: [],
      deptStoreValue: ref(),
      branchId: ref(),
      branchOptions: [],
      MappingbranchId: ref([]),
      MappingbranchOptions: [],
    });
    const copyselectOptionsSub = JSON.parse(
      JSON.stringify(selectOptionsSub.value)
    );
    let diffArrayMain: any = [];
    let diffArrayDept: any = [];
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const successpop = ref(false);
    const updatepop = ref(false);
    const editDisabled = ref(false);
    const alreadyexistpop = ref(false);
    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    onMounted(async () => {
      try {
        debugger;
        await LoadBranch();

        Object.keys(props.SubStoreRights).forEach((key) => {
          if (props.SubStoreRights[key])
            Rights.value[key] = props.SubStoreRights[key];
        });
        if (storeType == "2" && storeId != null) {
          debugger;
          label.value = t("btn.update");
          const result1 = await commonservice.GetBranchByStore(storeId);
          console.log(result1);
          let resFields1 = result1["result"].map((str) => parseInt(str));

          // selectOptionsSub.value.branchId = resFields1;

          // Ensure MappingBranchId is an array of numbers
          const BranchIds = Array.isArray(resFields1)
            ? resFields1
            : [];

          // Filter the array to include only valid options
          selectOptionsSub.value.branchId = BranchIds.filter(id =>
            selectOptionsSub.value.branchOptions.some(option => option.value === id)
          );

          const result = await commonservice.getStore(
            storeId,
            Number(router.query.StoreBranchId)
          );
          console.log(result);
          const resFields = result["result"];

          // selectOptionsSub.value.MappingbranchId = resFields[0].MappingBranchId;

          // Ensure MappingBranchId is an array of numbers
          const mappingBranchIds = Array.isArray(resFields[0].MappingBranchId)
            ? resFields[0].MappingBranchId
            : [];

          // Filter the array to include only valid options
          selectOptionsSub.value.MappingbranchId = mappingBranchIds.filter(id =>
            selectOptionsSub.value.MappingbranchOptions.some(option => option.value === id)
          );


          await LoadMainDeptStore();

          Object.keys(dataModelSub.value).forEach((key) => {
            if (resFields[0][key]) dataModelSub.value[key] = resFields[0][key];
          });
          debugger;
          let selectedMainStore: any = [];
          let selectedDeptStore: any = [];
          debugger;
          for (let i = 0; i < result["result"][0].MainStoreId.length; i++) {
            const foundItem: any = selectOptionsSub.value.mainStoreOptions.find(
              (item: any) =>
                item.Id === Number(result["result"][0].MainStoreId[i]) &&
                item.StoreBranchMapId ===
                Number(result["result"][0].MainStoreBranchMapId[i])
            );
            if (foundItem) {
              selectedMainStore.push({
                Id: Number(result["result"][0].MainStoreId[i]),
                StoreBranchMapId: foundItem.StoreBranchMapId,
              });
            }
          }
          for (
            let i = 0;
            i < result["result"][0].DepartmentStoreId.length;
            i++
          ) {
            const foundItem: any = selectOptionsSub.value.deptStoreOptions.find(
              (item: any) =>
                item.Id === Number(result["result"][0].DepartmentStoreId[i]) &&
                item.StoreBranchMapId ===
                Number(result["result"][0].DepartmentStoreBranchMapId[i])
            );
            if (foundItem) {
              selectedDeptStore.push({
                Id: Number(result["result"][0].DepartmentStoreId[i]),
                StoreBranchMapId: foundItem.StoreBranchMapId,
              });
            }
          }

          selectOptionsSub.value.mainStoreValue = selectedMainStore;
          selectOptionsSub.value.deptStoreValue = selectedDeptStore;
          selectOptionsSub.value.branchValue = resFields[0].IsBranchId;
          managedOptionsSub.value.managedValue = resFields[0].ManagedBy;
          selectOptionsSub.value.isTransaction =
            // resFields[0].TransactionBilling == true ? "true" : "false";

            diffArrayMain = selectOptionsSub.value.mainStoreValue;

          diffArrayDept = selectOptionsSub.value.deptStoreValue;

          loading.value = true;
        } else {
          loading.value = true;
          GetCode();
        }
      } catch (error) {
        console.error(error);
      }
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        IsSubmitSub();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    //Created Sucessfully Popup-Close
    function closetrigger() {
      routes.push({
        name: "StoreMaster",
      });
    }

    watch(
      props,
      (newValue: any) => {
        debugger;
        console.log("props Changed", newValue.SubStoreRights);
        Object.keys(newValue.SubStoreRights).forEach((key) => {
          if (newValue.SubStoreRights[key])
            Rights.value[key] = newValue.SubStoreRights[key];
        });
        // Rights.value.Create = newValue.SubStoreRights.Create;
        // Rights.value.Update = newValue.SubStoreRights.Update;
        // Rights.value.Read = newValue.SubStoreRights.Read;
        // Rights.value.Delete = newValue.SubStoreRights.Delete;
        // Rights.value.CreateId = newValue.SubStoreRights.CreateId;
        // Rights.value.UpdateId = newValue.SubStoreRights.UpdateId;
        // Rights.value.ReadId = newValue.SubStoreRights.ReadId;
        // Rights.value.DeleteId = newValue.SubStoreRights.DeleteId;
        GetCode();
      },
      { deep: true }
    );

    async function GetCode() {
      debugger;
      let EntityData: any = localStorage.getItem("EntityData");
      EntityData = JSON.parse(EntityData);
      let EntityId = Number(EntityData.EntityId);
      let data = {
        EntityId: EntityId,
        HospitalId: HospitalId,
        BranchId: 0,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      dataModelSub.value.Code = result;
    }
    //Branch Dropdown Change Function
    async function handleUpdateValueSub(value: string, option: any) {
      debugger;
      try {
        dataModelSub.value.IsBranchId = parseInt(value);
        selectOptionsSub.value.mainStoreOptions = mainStoreOptionsCopy.filter(
          (item: any) =>
            item.BranchId == selectOptionsSub.value.branchValue ||
            item.ManagedBy == 1
        );

        // selectOptionsSub.value.deptStoreOptions = deptStoreOptionsCopy.filter(
        //   (item: any) =>
        //     item.IsBranchId == selectOptionsSub.value.branchValue ||
        //     item.ManagedBy == 1
        // );

        if (storeId == null) {
        }
      } catch { }
    }
    function managedAtOnchangeSub() {
      debugger;

      dataModelSub.value.ManagedBy = Number(
        managedOptionsSub.value.managedValue
      );
      selectOptionsSub.value.branchValue = null;

      selectOptionsSub.value.mainStoreOptions = mainStoreOptionsCopy;
      selectOptionsSub.value.deptStoreOptions = deptStoreOptionsCopy;
      dataModelSub.value.Address =
        dataModelSub.value.ManagedBy == 1 ? AddressVar : "";
    }

    //Sub Store Submit Click Function

    const IsSubmitSub = async () => {
      debugger;
      Saveloader.value = true;
      console.log(dataModelSub);
      let StoreBranchMapResponse: any;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      try {
        dataModelSub.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        dataModelSub.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        dataModelSub.value.BranchId = BranchId;
        dataModelSub.value.HospitalId = HospitalId;
        dataModelSub.value.ModifiedBy = UserId;
        dataModelSub.value.CreatedBy = UserId;

        let EntityData: any = localStorage.getItem("EntityData");
        EntityData = JSON.parse(EntityData);
        let EntityId = Number(EntityData.EntityId);
        dataModelSub.value.EntityId = EntityId;

        // dataModelSub.value.TransactionBilling =
        //   selectOptionsSub.value.isTransaction == "true";

        let result: any;
        let msg: String = "";
        let id: any = 0;
        if (storeId != null) {
          dataModelSub.value.EntityOperationId = Rights.value.UpdateId;

          result = await commonservice.updateStore(dataModelSub.value);
          msg = "Updated Successfully";
          id = storeId;
        } else {
          dataModelSub.value.EntityOperationId = Rights.value.CreateId;

          result = await commonservice.insertStore(dataModelSub.value);
          msg = "Inserted Successfully";
          id = result["result"];
        }
        console.log(result);

        let message = result["ErrorInfo"].ErrorCode;
        if (result["result"] == "Already" && message == null) {
          Saveloader.value = false;
          alreadyexistpop.value = true;
        } else if (message == null) {
          //Branch Mapping Insert
          let branchIdValue: any = selectOptionsSub.value.branchId ?? "";
          let dataarr: any = [];
          for (let i = 0; i < branchIdValue.length; i++) {
            let obj: any = {};
            obj["BranchId"] = branchIdValue[i];
            (obj["StoreId"] = parseInt(id)),
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedBy"] = UserId),
              (obj["CreatedBy"] = UserId);
            dataarr.push(obj);
          }
          StoreBranchMapResponse = await commonservice.insertStoreBranchMapping(
            dataarr
          );

          console.log(StoreBranchMapResponse);
          let messageMap = StoreBranchMapResponse["ErrorInfo"].ErrorCode;

          let resultmap: any;
          if (selectOptionsSub.value.mainStoreValue != undefined) {
            let storeValue = selectOptionsSub.value.mainStoreValue ?? "";
            let StoreIdbrMapId = StoreBranchMapResponse["result"].filter(
              (item: any) => item.BranchId == BranchId
            );
            for (let i = 0; i < storeValue.length; i++) {
              let dataModelMapping = {
                StoreId: storeValue[i].Id,
                StoreMappingId: id,
                CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedBy: UserId,
                CreatedBy: UserId,
                StoreBranchMapId: StoreIdbrMapId[0].Id,
                StoreIdbrMapId: storeValue[i].StoreBranchMapId,
              };
              result = await commonservice.insertStoreMapping(dataModelMapping);
            }
          }
          if (selectOptionsSub.value.deptStoreValue != undefined) {
            let deptStoreValue = selectOptionsSub.value.deptStoreValue ?? "";
            let StoreIdbrMapId = StoreBranchMapResponse["result"].filter(
              (item: any) => item.BranchId == BranchId
            );
            for (let i = 0; i < deptStoreValue.length; i++) {
              let dataModelMapping = {
                StoreId: id,
                StoreMappingId: deptStoreValue[i].Id,
                CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedBy: UserId,
                CreatedBy: UserId,
                StoreBranchMapId: deptStoreValue[i].StoreBranchMapId,
                StoreIdbrMapId: StoreIdbrMapId[0].Id,
              };
              result = await commonservice.insertStoreMapping(dataModelMapping);
            }
          }

          if (messageMap == null) {
            if (storeId != null) {
              Saveloader.value = false;
              updatepop.value = true;
            } else {
              Saveloader.value = false;
              successpop.value = true;
            }
          }
        }
      } catch (error) {
        console.log(error);
        Saveloader.value = false;
      }
    };

    //Main Store/Dept Store Multi Select Load function
    async function LoadMainDeptStore() {
      debugger;
      // selectOptionsSub.value.mainStoreOptions.length = 0;
      // selectOptionsSub.value.mainStoreValue = ref();
      // selectOptionsSub.value.deptStoreOptions.length = 0;
      // selectOptionsSub.value.deptStoreValue = ref();

      try {
        if (selectOptionsSub.value.MappingbranchId.length != 0) {
          let result = await commonservice.ListByBranchId(
            usersData.UserId,
            usersData.OrganizationId,
            usersData.Admin,
            selectOptionsSub.value.MappingbranchId.join(",")
          );

          let arr = result["result"]
            .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId)
            .map((item) => {
              item.name = item.Name + "(" + item.CurrentBranchName + ")";
              item.value = {
                Id: item.Id,
                StoreBranchMapId: item.StoreBranchMapId,
              };
              return item;
            });

          selectOptionsSub.value.mainStoreOptions = arr.filter(
            (item) => item.StoreTypeId === 1
          );

          selectOptionsSub.value.deptStoreOptions = arr.filter(
            (item) => item.StoreTypeId === 3
          );

          mainStoreOptionsCopy = JSON.parse(
            JSON.stringify(selectOptionsSub.value.mainStoreOptions)
          );

          deptStoreOptionsCopy = JSON.parse(
            JSON.stringify(selectOptionsSub.value.deptStoreOptions)
          );
        } else {
          selectOptionsSub.value.mainStoreOptions = [];
          selectOptionsSub.value.deptStoreOptions = [];
        }
      } catch (error) { }
    }

    //Clear Function
    function IsClear() {
      Object.assign(dataModelSub.value, copydataModelSub);
      Object.assign(selectOptionsSub.value, copyselectOptionsSub);
      managedOptionsSub.value.managedValue = null;

      GetCode();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      dataModelSub.value.Name = "";
      //showDialog.value = true
    }

    async function LoadBranch() {
      debugger;
      const dataModel = {
        Dml_Indicator: "LBRAN",
        hospital_id: "USH00005",
      };

      const data_response = await LoginService.GetBranchesByUserId(
        usersData.UserId
      );

      selectOptionsSub.value.branchOptions = data_response["result"].map(
        (item) => {
          item.name = item.BranchName;
          item.value = item.BranchId;
          return item;
        }
      );
      selectOptionsSub.value.MappingbranchOptions = data_response["result"].map(
        (item) => {
          item.name = item.BranchName;
          item.value = item.BranchId;
          return item;
        }
      );
    }

    return {
      LoadBranch,
      loading,
      dataModelSub,
      selectOptionsSub,
      handleUpdateValueSub,
      IsSubmitSub,
      LoadMainDeptStore,
      childref,
      successpop,
      updatepop,
      closetrigger,
      editDisabled,
      alreadyclosetrigger,
      alreadyexistpop,
      managedOptionsSub,
      managedAtOnchangeSub,
      IsClear,
      label,
      Saveloader,
      Rights,
    };
  },
  async created() {
    // this.LoadMainDeptStore();
  },
});
</script>
